export enum ContentTags {
  CONFIGURATION = "configuration",
  LOGS = "logs",
}
